import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { applyActionCode, checkActionCode } from "firebase/auth";
import "./EmailChange.css"; // Reuse styling from the email change CSS

const VerifyAndChangeEmail = ({ actionCode }) => {
  const [newEmail, setNewEmail] = useState(null);
  const [statusMessage, setStatusMessage] = useState("Verifying your email change request...");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const APP_NAME = "Guardian Mobile"; // Replace with your app name

  useEffect(() => {
    const verifyEmailChange = async () => {
      try {
        const info = await checkActionCode(auth, actionCode);
        // Firebase returns the email address that is going to be set
        setNewEmail(info.data.email);
        setStatusMessage(`Your sign-in email for ${APP_NAME} is set to change to ${info.data.email}.`);
      } catch (err) {
        setStatusMessage(`Error verifying email change: ${err.message}`);
      }
    };
    verifyEmailChange();
  }, [actionCode]);

  const handleConfirm = async () => {
    try {
      await applyActionCode(auth, actionCode);
      setStatusMessage(`Your email has been updated to ${newEmail} successfully! 🎉`);
      setIsConfirmed(true);
    } catch (err) {
      setStatusMessage(`Error changing email: ${err.message}`);
    }
  };

  return (
    <div className="email-change-container">
      <div className="email-change-card">
        <div className="logo-container">
          <img src="/guardianLogo.png" alt="Logo" className="logo" />
        </div>
        <h2 className="email-change-title">Verify and Change Email Address</h2>
        <p className="email-change-instructions">
          {statusMessage}
        </p>
        {!isConfirmed && newEmail && (
          <button onClick={handleConfirm} className="email-change-button">
            Confirm Email Change
          </button>
        )}
        {isConfirmed && (
          <p className="status-message">
            Your sign-in email for {APP_NAME} was successfully changed to {newEmail}.
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyAndChangeEmail;
